<script setup>
import {
  BadgeCheck,
  Bell,
  ChevronsUpDown,
  CreditCard,
  LogOut,
  Sparkles,
} from "lucide-vue-next";

import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from '@/components/ui/avatar';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from '@/components/ui/sidebar';

import { useViewStore } from '@/stores/viewStore'

const viewStore = useViewStore();

import { useUserStore } from '@/stores/userStore';

const userStore = useUserStore();

const props = defineProps({
  user: { type: Object, required: true },
});

const { isMobile } = useSidebar();

</script>

<template>
  <SidebarMenu>
	<SidebarMenuItem>
		<!-- Der ganze Knopf ist der Link, nicht nur der Text: ein Klick auf das
		     Symbol oder den Rand - und bei eingeklappter Seitenleiste jeder
		     Klick - lief sonst ins Leere. -->
		<SidebarMenuButton as-child :tooltip="`Log out ${viewStore.username ?? ''}`">
			<a href="/logout">
				<LogOut />
				<span>Log out {{ viewStore.username }}</span>
			</a>
		</SidebarMenuButton>
	</SidebarMenuItem>
  </SidebarMenu>
</template>
